import { createStore } from 'vuex'
import getters from './getters'
import user from './modules/user'
import order from './modules/order'

const store = createStore({
  modules: {
    user,
    order
  },
  getters
})

export default store
